/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import Link from "next/link";

import { Plate } from "src/classes/plate/Plate";
import { TopbarTextButton } from "src/components/Plate/ShareMenu/ShareButton";
import { StyledLockButton } from "src/components/Plate/Topbar/lib/styles";
import { Locked as LockedIcon } from "src/components/UI/Icons";
import { Unlocked as UnlockedIcon } from "src/components/UI/Icons";
import { UnderlineOnlyLinkStyle, UnstyledLink } from "src/components/UI/Links";
import { Tooltip } from "src/components/UI/Tooltip";

/* ------------------------- Buttons ---------------------- */

export const Lock = ({ plate, styles }: { plate: Plate; styles?: React.CSSProperties }) => {
  const isPublic = plate.observe((state) => state.isPublic);
  return (
    <Tooltip
      tooltipText={isPublic ? "Plate is public. Click to change." : "Plate is private. Click to change."}
      delayShow={1000}
    >
      <StyledLockButton
        isPublic={isPublic}
        onClick={() => plate.changePrivacy()}
        id="cy-lock-button"
        style={styles}
      >
        {isPublic ? <UnlockedIcon /> : <LockedIcon />}
      </StyledLockButton>
    </Tooltip>
  );
};

/* ------------------------- Sign In / Ownername ---------------------- */

export const Ownername = ({ ownername }: { ownername: string }) => {
  return (
    <div style={{ whiteSpace: "nowrap" }}>
      <Link href={`/user/${ownername}`} passHref>
        <UnderlineOnlyLinkStyle>{ownername}</UnderlineOnlyLinkStyle>
      </Link>
      <span style={{ userSelect: "none" }}>&nbsp;/&nbsp;</span>
    </div>
  );
};

export const SignIn = () => (
  <Link href="/signin" passHref>
    <UnstyledLink>
      <TopbarTextButton>SIGN_IN</TopbarTextButton>
    </UnstyledLink>
  </Link>
);
